import React from 'react';
import "../../resources/styles/components/verify-header.scss";

type Props = {};

/**
 * Component to display 2FA header in multiple locations.
 */

export const VerifyHeader: React.FunctionComponent<Props> = props => {
	return (
       
		<div className="verify-header">
            <span className="mp-icon-security security-icon"/>
            <h1 className="header-title">
                Please Verify Your Identity
            </h1>
           
                <div className="header-info">
                    It appears that you're logging in from a new device. For security purposes, we need to confirm your identity.
                <br/>
                    We will send you a security code to your preferred method of communication below.
                </div>
            
        </div>
	);
};